import constantObject from 'utilities/constantObject';

export const DASHBOARD_STATES = constantObject([
  'IDLE',
  'LOADING',
  'LOADING_FAILED',
  'UNSET',
  'SET',
  'SAVING',
  'SAVING_FAILED',
]);
